import { render, staticRenderFns } from "./ModalEditTrip.vue?vue&type=template&id=19fa2794&scoped=true&"
import script from "./ModalEditTrip.vue?vue&type=script&lang=js&"
export * from "./ModalEditTrip.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTrip.vue?vue&type=style&index=0&id=19fa2794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa2794",
  null
  
)

export default component.exports